export default __webpack_public_path__ + "static/media/thumbnail1.1ffd9345.jpg";